"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapGeolocationProperties = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

var _reactLoadable = _interopRequireDefault(require("react-loadable"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var _Validations = require("../../Validations");

var _FieldMapper = _interopRequireWildcard3(require("./FieldMapper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LoadableGeolocation = (0, _reactLoadable.default)({
  loader: function loader() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../Geolocation"));
    }).then(_FieldMapper.enhance);
  },
  render: _FieldMapper.attachComponentToFormLoadableRender,
  loading: function loading() {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }
});

var getValidations = function getValidations(field) {
  var validations = [];

  if (field.properties.isRequired) {
    validations.push(_Validations.geoLocationRequireValidation);
  }

  if (field.properties.showState || field.properties.showZipCode) {
    validations.push(_Validations.childComponentValidation);
  }

  return validations;
};

var mapMapProperties = function mapMapProperties(_ref) {
  var field = _ref.field,
      model = _ref.model,
      googleMapsKey = _ref.googleMapsKey;
  var geolocationDefaultValue = {
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    latitude: null,
    longitude: null
  };
  return _objectSpread(_objectSpread({}, model), {}, {
    component: LoadableGeolocation,
    editor: field.properties.editor,
    fields: {
      showAddress1: field.properties.showAddress1,
      showAddress2: field.properties.showAddress2,
      showCity: field.properties.showCity,
      showState: field.properties.showState,
      showZipCode: field.properties.showZipCode
    },
    googleMapsKey: googleMapsKey,
    onChange: function onChange(location) {
      return {
        value: Array.isArray(location) ? location[0] : location
      };
    },
    onlyValidateOnBlur: true,
    name: model.id,
    statePattern: field.properties.statePattern,
    statePatternMessage: field.properties.statePatternMessage,
    validations: getValidations(field),
    value: model.value || geolocationDefaultValue,
    zipCodePattern: field.properties.zipCodePattern,
    zipCodePatternMessage: field.properties.zipCodePatternMessage
  });
};

var mapGeolocationProperties = function mapGeolocationProperties(_ref2) {
  var field = _ref2.field,
      htmlId = _ref2.htmlId,
      value = _ref2.value,
      googleMapsKey = _ref2.googleMapsKey,
      onValidation = _ref2.onValidation;
  var model = (0, _FieldMapper.default)(field, htmlId, value, undefined, onValidation);

  if (field.properties.editor === "Map" || field.properties.editor === "NoMap") {
    return mapMapProperties({
      field: field,
      model: model,
      googleMapsKey: googleMapsKey
    });
  }

  return null;
};

exports.mapGeolocationProperties = mapGeolocationProperties;